module.exports = __webpack_public_path__ + "img/传授知识@2x.ac37a1ac.png";